/* global appData, Mailcheck, ui */

const emailSpellcheck = {
	$alert: null,
	$email: document.getElementById('email'),
	initialize: () => {
		const secondLevelDomains = [
			'aim', 'aol', 'att', 'bellsouth', 'btinternet', 'charter', 'comcast', 'cox', 'earthlink', 'embarqmail', 'facebook',
			'frontier', 'gmail', 'gmx', 'google', 'googlemail', 'hotmail', 'icloud', 'juno', 'live', 'mac', 'mail', 'me', 'msn',
			'optonline', 'optusnet', 'outlook', 'qq', 'roadrunner', 'rocketmail', 'rogers', 'sbcglobal', 'shaw', 'sky',
			'sympatico', 'telus', 'verizon', 'web', 'windstream', 'xtra', 'yahoo', 'ymail'
		];
	
		const $emailSuggestionAlert = document.getElementById('emailSuggestionAlert');
		const $emailSuggestion = document.getElementById('emailSuggestion');
	
		emailSpellcheck.$email.addEventListener('blur', () => {
			Mailcheck.run({
				email: emailSpellcheck.$email.value,
				secondLevelDomains,
				suggested: (suggestion) => {
					const suggestedEmailButtonHtml = `<button type="button" class="link" onclick="updateEmail('${suggestion.full}')">${suggestion.full}</button>`;
					$emailSuggestion.innerHTML = appData.strings.emailSuggestion.replace('{suggestedEmailAddress}', suggestedEmailButtonHtml);
					if (emailSpellcheck.$alert === null) {
						emailSpellcheck.$alert = ui.alert($emailSuggestionAlert, {
							closable: true,
							type: 'info',
							open: false
						});
						$emailSuggestionAlert.classList.remove('noDisplay');
					}
					emailSpellcheck.$alert.open();
				},
				empty: () => {
					if (emailSpellcheck.$alert !== null) {
						emailSpellcheck.$alert.close();
					}
				}
			});
		});
	}
};

// The suggested email button needs access to this function so we need to add it to the window.
window.updateEmail = (email) => {
	emailSpellcheck.$email.value = email;
	emailSpellcheck.$alert.close();
};

export default emailSpellcheck;